/* eslint-disable no-unused-expressions */
/* eslint-disable no-await-in-loop */

import axios from 'axios'
import WasteRegisterEntity from '../utils/WasteRegisterEntity'
import WasteRegisterNormalizer from '../normalizer/WasteRegisterNormalizer'
import { getMemberData, isLastPage, getNextPage } from './hydra-services'
import CollapseDto from '../utils/CollapseDto'
import { formatToInputDateWDH } from '../utils/date-utils'

export interface DataStructure {
  columns: string[]
  data: string[][]
}

interface DataType {
  [key: string]: string
}

export interface TableDto {
  dataIds: string[]
  data: DataType[]
  columnNames: string[]
}

export function formatdataExcel(dataSet: WasteRegisterEntity[]) {
  const dataRaw: string[][] = []
  const columnNames = Object.keys(dataSet[0])
  dataSet.map((data) => dataRaw.push(Object.values(data)))
  const datafinal = [
    {
      columns: columnNames,
      data: dataRaw,
    },
  ]

  return datafinal
}

export async function getWasteRegisters(
  startDate: Date,
  endDate: Date,
  listofIds: string[]
): Promise<WasteRegisterEntity[]> {
  const expeditionDateBefore = `&dateExpedition[before]=${formatToInputDateWDH(
    endDate
  )}`
  const expeditionDateAfter = `&dateExpedition[after]=${formatToInputDateWDH(
    startDate
  )}`

  let url = `${
    process.env.REACT_APP_BASE_API_WDH_URL
  }/registre_dechets?perPage=${100}${expeditionDateBefore}${expeditionDateAfter}`

  listofIds.forEach((id) => {
    url += `&fkadresse.fkentreprise[]=${id}`
  })

  const resultatFinal: WasteRegisterEntity[] = []

  try {
    let hasMorePage = true
    while (hasMorePage) {
      const resp = await axios.get(url)
      const result = getMemberData(resp.data)
      WasteRegisterNormalizer.normalize(result).forEach(
        (register: WasteRegisterEntity) => {
          resultatFinal.push(register)
        }
      )
      // fetch nextPage
      hasMorePage = !isLastPage(resp.data)
      url = `${process.env.REACT_APP_BASE_API_WDH_URL}${getNextPage(resp.data)}`
    }
  } catch (err) {
    throw new Error(
      `Erreur lors de l'obtention du registre des déchet avec l'url: ${url}`
    )
  }
  return resultatFinal
}
export function filterById(ids: string[], globallist: TableDto): TableDto {
  const result: TableDto = {
    data: [],
    dataIds: [],
    columnNames: globallist.columnNames,
  }
  ids.forEach((id) => {
    const index = globallist.dataIds.indexOf(id)
    if (globallist.data[index] !== undefined) {
      result.dataIds.push(id)
      result.data.push(globallist.data[index])
    }
  })
  return result
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function concatresult(child: any, parent: TableDto): TableDto {
  const original = parent
  if (child.data !== undefined || child.dataIds !== undefined) {
    original.data = original.data.concat(child.data)
    original.dataIds = original.dataIds.concat(child.dataIds)
    original.columnNames = child.columnNames
  }
  return original
}

export function prepareTableData(perimetrelist: CollapseDto[]): TableDto {
  const result: TableDto = { data: [], dataIds: [], columnNames: [] }
  for (let index = 0; index < perimetrelist.length; index += 1) {
    if (perimetrelist[index].children !== undefined) {
      perimetrelist[index].children?.forEach((child) => {
        if (child.type === 'table') {
          concatresult(child, result)
        } else {
          const tmpArray = [child]
          const sresult = prepareTableData(tmpArray)
          concatresult(sresult, result)
        }
      })
    }
  }

  return result
}
